import React, { createContext, useContext, useEffect, useState } from 'react';
import { BorrowerOrGuarantorListItem } from './components/BorrowerOrGuarantorListItem';
import BorrowerDetail from './BorrowerDetail/BorrowerDetail';
import { SearchBox } from '../LoanList/LoanList';
import { useGetBorrowers } from '../../../services/borrower/querys';
import { useGetOwnerships } from '../../../services/ownership/querys';
import { useParams } from 'react-router-dom';
import { BorrowerOrGuarrantorDetailViewContext } from '../Private';
import Spin from '../../../components/Atoms/Loader/Spin';

interface Props {
  children?: React.ReactNode;
}

const filterByNameOrLoanName = (term: string) => (items: any[]) =>
  items.filter(item => {
    const lowerTerm = term.toLowerCase();

    const matchesBorrowerName = item.name?.toLowerCase().includes(lowerTerm);
    const matchesLoanName = item.loans?.some(
      (loan: any) => loan.name?.toLowerCase().includes(lowerTerm)
    );

    return matchesBorrowerName || matchesLoanName;
  });

const Borrowers: React.FC<Props> = ({ }) => {

  const { borrowerId } = useParams();

  const { setHandlerVisible }: any = useContext(BorrowerOrGuarrantorDetailViewContext);
  const { data: borrowers, fetching: borrowersLoading } = useGetBorrowers();
  const { data: ownerships, fetching: ownershipsLoading } = useGetOwnerships();

  const [filterFn, setFilterFn] = useState<(list: any[]) => any[]>(() => (list: any) => list);

  useEffect(() => {
    if(borrowerId) 
      setHandlerVisible(borrowerId);
  }, [borrowerId])

  const onSearchHandler = (term: string) => {
    if (term) {
      setFilterFn(() => filterByNameOrLoanName(term));
    } else {
      setFilterFn(() => (list: any) => list);
    }
  };

  const filteredBorrowers = filterFn(borrowers);
  const filteredOwnerships = filterFn(ownerships);
  return (
    <div className="borrowers">
      <div className='top-container'>
        <div className='title'>
          Borrowers
        </div>
        <div>
        </div>
        <div>
          <SearchBox onSearch={onSearchHandler} />
        </div>
      </div>
      <div className='borrowers-container'>
        {borrowersLoading || ownershipsLoading && <Spin />}
        {filteredBorrowers?.map((borrower: any) => (
          <BorrowerOrGuarantorListItem key={borrower._id} {...borrower} type='borrower'/>
        ))}
        {filteredOwnerships?.map((ownership: any) => (
          <BorrowerOrGuarantorListItem key={ownership._id} {...ownership} type='guarantor'/>
        ))}
      </div>

      <BorrowerDetail/>
    </div>
  );
};

export default Borrowers;